import { stringify, ParsedUrlQuery, parse } from 'querystring';
import { PROD_URL } from '../constants';
import appendTrailingSlash from './appendTrailingSlash';

type CreateUrlOptions = {
  pathname: string;
  query?: ParsedUrlQuery;
};

export const createUrl = ({ pathname, query }: CreateUrlOptions): string => {
  const querystring = stringify(query);
  const url = appendTrailingSlash(pathname)
    + (querystring ? `?${querystring}` : '');
  return url;
};

export const removeQueryParam = (url: string, ...params: string[]): string => {
  const { pathname, search } = new URL(url, PROD_URL);
  const query = parse(search.slice(1));

  params.forEach((key) => {
    delete query[key];
  });

  return createUrl({ pathname, query });
};
